<div class="d-flex align-item-center justify-content-between" *ngIf="t==1 && show"
  style="background: #fff;border-radius: 15px;">
  <div class="flex-grow-1 px-0" [class.valid]="model"
    [ngClass]="{'form-item': formItem, 'google-part custom-form-v5': !formItem}">
    <input #addressInput #placesRef="ngx-places" ngx-gp-autocomplete type="text" [(ngModel)]="model" [options]='options1'
      (onAddressChange)="handleAddressChange($event);" [ngClass]="customClass"
      class="form-control w-100 px-3 pt-3" (click)="removeZipCode()" name="search_field"
      (focus)="onAddressFocus()" (blur)="handleManualAddressChange(); onAddressBlur()"
      [ngClass]="invalid_input_class" placeholder="" id="zip_code" [class.has-error]="invalid_input_class == 'model'" />
    <label for="text" class="label_class" [ngClass]="{top_class:  model?.length>0}">
      {{label}}
    </label>

  </div>
</div>
<form action="" class="m-0" autocomplete="off">
  <div class="-input-field form-item" *ngIf="t==2 && show">
    <input #addressInput #placesRef="ngx-places" ngx-gp-autocomplete type="text" name="search_field" [(ngModel)]="model"
      [options]='options1' (onAddressChange)="model='';handleAddressChange($event,search_canada)" autocomplete="off"
      placeholder="" [disabled]="disabled" id="text" style="border-bottom: 1px solid #BCC0C3;"
      [ngClass]="{'has-values': model, 'custom-padding': from_page}" class="-input-fill invalid_input_class"
      autocomplete="_away" (click)="removeZipCode()" [class]="formItem"
      (focus)="onAddressFocus()" (blur)="handleManualAddressChange(); onAddressBlur()" />
    <label for="text" class="label_class" [ngClass]="{top_class:  model?.length>0}">
      {{label}}
    </label>
  </div>
  <!-- <div class="input-field custom-form-v5" *ngIf="t==2 && show">
    <input #placesRef="ngx-places" ngx-gp-autocomplete type="text" name="search_field" [(ngModel)]="model" [options]='options1'
      (onAddressChange)="model='';handleAddressChange($event,search_canada)" placeholder=""
      (click)="removeZipCode()" id="text" style="border-bottom: 1px solid #BCC0C3;" [ngClass]="{'has-values': model}"
      class="input-fill" autocomplete="_away" [ngClass]="invalid_input_class" />
    <label for="text" [ngClass]="{modelClass: model && model.length>0}" class="zipcolor">
      {{label}}
    </label>
  </div> -->
</form>